import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Wrapper "invisibile" che invia un page_view a GA4 ad ogni cambio di route.
 * Va montato una volta sola dentro <BrowserRouter>. Rispetta Consent Mode v2
 * (denied di default) — se l'utente non ha ancora accettato, gtag scarta l'evento.
 * Esclude automaticamente admin + preview (vedi analytics.js).
 */
export default function AnalyticsRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    // Piccolo delay per lasciare aggiornare document.title (Helmet)
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
  return null;
}
